var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-line"},[_c('googlemaps-map',{staticClass:"map",attrs:{"center":_vm.center,"zoom":_vm.zoom,"options":_vm.mapOptions},on:{"update:center":function($event){_vm.center=$event},"update:zoom":function($event){_vm.zoom=$event}}},_vm._l((_vm.computedMarkers),function(marker){return _c('googlemaps-marker',{key:marker.id,attrs:{"position":marker.position,"label":{
        color: 'white',
        fontSize: '12px',
        text: ("" + (marker.id+1)),
      }},on:{"click":function($event){return _vm.selectMarker(marker.id)}}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }